var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkedComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5L4.33333 6.33333L7 3.66667M3.13333 9H6.86667C7.6134 9 7.98677 9 8.27199 8.85468C8.52287 8.72684 8.72684 8.52287 8.85468 8.27199C9 7.98677 9 7.6134 9 6.86667V3.13333C9 2.3866 9 2.01323 8.85468 1.72801C8.72684 1.47713 8.52287 1.27316 8.27199 1.14532C7.98677 1 7.6134 1 6.86667 1H3.13333C2.3866 1 2.01323 1 1.72801 1.14532C1.47713 1.27316 1.27316 1.47713 1.14532 1.72801C1 2.01323 1 2.3866 1 3.13333V6.86667C1 7.6134 1 7.98677 1.14532 8.27199C1.27316 8.52287 1.47713 8.72684 1.72801 8.85468C2.01323 9 2.3866 9 3.13333 9Z",
    stroke: "#48D767",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkedComplete);
export default __webpack_public_path__ + "static/media/marked-complete.8bdf122f.svg";
export { ForwardRef as ReactComponent };